import { createContext } from 'react'

import type { ApolloError } from '@apollo/client'
import type { FxQuote, GetFxQuoteInput } from '@shared/graphql'

export interface TransferWithFx {
  /**
   * Refetch Quotes.
   */
  refetch: (input: GetFxQuoteInput) => Promise<FxQuote | undefined>
  /**
   * A quote object representing the latest quote that the user has requested info for.
   */
  quote?: FxQuote
  /**
   * Whether or not the context is loading data. Should return true if fetching an FX qoute.
   */
  loading?: boolean
  /**
   * An error object related to fetching the FX quote.
   */
  error?: ApolloError
}

export const TransferWithFxContext = createContext<TransferWithFx>({
  refetch: () => ({}) as Promise<FxQuote | undefined>,
})
